export const MARKET_SLUGS = {
    ES: 'es',
    EN: 'en',
    EN_GB: 'en-gb',
    EN_CA: 'en-ca',
    EN_NZ: 'en-nz',
    ON: 'on',
    FI: 'fi',
    SV: 'sv',
    IE: 'ie',
    NO: 'no',
    ROG: 'rog',
    ROW: 'row'
} as const;
